import type { IToolUserDocumentListRowApi } from '@/types/toolUserDocument';

export class ToolUserDocumentItem {
    public createdAt: string;
    public fileName: string;
    public id: number;
    public isValid: 0 | 1;
    public originalFileName: string;
    public toolUserId: number;
    public toolUserName: string;
    public typeId: number;

    constructor(data: IToolUserDocumentListRowApi) {
        this.id = data.id;
        this.createdAt = data.created_at;
        this.typeId = data.type_id;
        this.isValid = data.is_valid;
        this.fileName = data.file_name;
        this.originalFileName = data.original_file_name;
        this.toolUserName = data.tool_user_name;
        this.toolUserId = data.tool_user_id;
    }
}
